import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { LogService } from '../log/log.service';
import { FlashMessagesService } from '../flash-messages/service/flash.messages.service';

@Injectable()
export class ErrorHandlerService {

  constructor(private logService: LogService, private flashMessageService: FlashMessagesService) {
  }

  public handle(logMessage: string, flashMessage = '', handleType = ErrorHandlerType.THROW_ERROR) {
    // Return a function that conforms to the shape if a catch callback
    return (error: any) => {
      return this.processError(logMessage, flashMessage, handleType, error);
    };
  }

  public handleObservable(logMessage: string, flashMessage = '') {
    return this.handle(logMessage, flashMessage, ErrorHandlerType.THROW_OBSERVABLE);
  }

  public throw(logMessage: string, flashMessage = '', handleType = ErrorHandlerType.THROW_ERROR, error = logMessage) {
    return this.processError(logMessage, flashMessage, handleType, error);
  }

  private processError(logMessage: string, flashMessage = '', handleType = ErrorHandlerType.THROW_ERROR, error = null) {
    if (logMessage) {
      this.logService.error(logMessage);
    }

    if (flashMessage) {
      this.flashMessageService.error(flashMessage);
    }

    switch (handleType) {
      case ErrorHandlerType.DO_NOT_THROW:
        // Do not thow re-throw the error
        break;

      case ErrorHandlerType.THROW_OBSERVABLE:
        return Observable.throw(this.getErrorMessage(error));

      // case ErrorHandlerType.THROW_ERROR:
      default:
        throw new Error(error);
    }
  }

  private getErrorMessage(error) {
    if (error && error.json && error.json().error) {
      return error.json().error;
    } else {
      return 'An error occurred';
    }
  }

  /**
   * Remove the status code and the exception from the given backend error message
   * This method must be ONLY used for backend error messages with format:
   * "Response with status [statusCode]: WebApplicationException: [errorMessage]"
   *
   * @param backendErrorMessage
   * @returns {string} error message
   */
  public getErrorMessageFromBackendError(backendErrorMessage: string): string {
    return backendErrorMessage.substring(backendErrorMessage.lastIndexOf('WebApplicationException: ')
      + 'WebApplicationException: '.length);
  }
}

export enum ErrorHandlerType {
  DO_NOT_THROW,
  THROW_ERROR,
  THROW_OBSERVABLE
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/utils/error-handler.service.ts